import styled from 'styled-components';
import TasksSection from './component';

export default styled(TasksSection)`
  display: flex;
  height: 100%;

  .side-column {
    height: 100%;
    width: 320px;
  }

  .filters-container {
    padding: 15px 16px;
    width: 100%;
    height: 190px;
    display: flex;
    justify-content: space-around;
    flex-direction: column;
  }

  .list-container {
    height: calc(100% - 190px);
    background-color: var(--grey700);
    overflow: scroll;
    position: relative;
    padding: 16px 0 0 0;

    &::-webkit-scrollbar {
      width: 4px;
      height: 4px;
    }

    &::-webkit-scrollbar-thumb {
      border-radius: 4px;
      background: #e2e8ee;
    }
  }

  .main-content {
    background-color: #3b4f63;
    width: calc(100% - 320px);
    height: 100%;
  }
`;
